import { useId } from 'react';
import type { CarbonIconType } from '@carbon/icons-react';
import styles from './SettingsSection.module.scss';

export interface SettingsSectionProps {
  title: string;
  description?: string;
  icon?: CarbonIconType;
  children: React.ReactNode;
  layout?: 'stack' | 'grid';
}

export function SettingsSection({
  title,
  description,
  icon: Icon,
  children,
  layout = 'stack',
}: SettingsSectionProps) {
  const titleId = useId();

  return (
    <section className={styles.section} aria-labelledby={titleId}>
      <div className={styles.header}>
        <h3
          id={titleId}
          className={Icon ? `${styles.title} ${styles.titleWithIcon}` : styles.title}
        >
          {Icon && (
            <span className={styles.titleIcon} aria-hidden>
              <Icon size={20} />
            </span>
          )}
          {title}
        </h3>
        {description && (
          <p className={styles.description}>{description}</p>
        )}
      </div>
      <div className={layout === 'grid' ? styles.grid : styles.stack}>
        {children}
      </div>
    </section>
  );
}
